<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">账龄分析表</span>
				<div class="float-right">
					<Button size="s" icon="fa fa-print" @click="printPage">打印</Button>
					<Button size="s" icon="fa fa-download" @click="exportExcel">导出</Button>
				</div>
		</div>
		<div class="margin-right-left margin-top">
			<div class="h-input-group" v-width="180">
				<DatePicker v-model="params.end" style="width: 160px" :clearable="false"
							format="YYYY-MM-dd"></DatePicker>
			</div>
			<Checkbox v-model="params.showRatio" style="margin-left: 10px;">显示比例</Checkbox>
			<Checkbox v-model="params.hideZero">余额为0不显示</Checkbox>
			<div class="float-right">
				<Button color="primary" icon="fa fa-search" :loading="loading" @click="doSearch">刷新</Button>
				<Button icon="fa fa-print" @click="print">打印</Button>
			</div>
		</div>
		<Row class="h-panel-body" type="flex" :space-x="10">
			<Cell :flex="1" style="overflow-x: auto;">
				<table id="ageTable" class="cus-table">
					<thead class="header">
					<tr>
						<td rowspan="2">科目编码</td>
						<td rowspan="2">科目名称</td>
						<td colspan="2">期初余额</td>
						<td colspan="2">本期发生额</td>
						<td colspan="2">期末余额</td>
						<td :colspan="params.showRatio?2:1">30天以内</td>
						<td :colspan="params.showRatio?2:1">30-60天</td>
						<td :colspan="params.showRatio?2:1">60-90天</td>
						<td :colspan="params.showRatio?2:1">90-180天</td>
						<td :colspan="params.showRatio?2:1">180-360天</td>
						<td :colspan="params.showRatio?2:1">360-1080天</td>
						<td :colspan="params.showRatio?2:1">1080天以上</td>
					</tr>
					<tr>
						<td>借方</td>
						<td>贷方</td>
						<td>借方</td>
						<td>贷方</td>
						<td>借方</td>
						<td>贷方</td>
						<template v-if="params.showRatio">
							<td>金额</td><td>比例</td>
							<td>金额</td><td>比例</td>
							<td>金额</td><td>比例</td>
							<td>金额</td><td>比例</td>
							<td>金额</td><td>比例</td>
							<td>金额</td><td>比例</td>
							<td>金额</td><td>比例</td>
						</template>
						<template v-else>
							<td>金额</td><td>金额</td><td>金额</td><td>金额</td><td>金额</td><td>金额</td><td>金额</td>
						</template>
					</tr>
					</thead>
					<tbody>
					<tr v-for="(item,index) in displayList" :key="index">
						<td>{{item.subjectCode}}</td>
						<td>{{item.subjectName}}</td>
						<td class="text-right" :class="{tip:item.openingBalance<0}">{{item.openingBalance|numFormat}}</td>
						<td class="text-right">&nbsp;</td>
						<td class="text-right">{{item.debitAmount|numFormat}}</td>
						<td class="text-right">{{item.creditAmount|numFormat}}</td>
						<td class="text-right" :class="{tip:item.endingBalance<0}">{{item.endingBalance|numFormat}}</td>
						<td class="text-right">&nbsp;</td>
						<td class="text-right" v-for="(age,ai) in item.ageList" :key="ai">
							<span v-if="params.showRatio">{{age.amount|numFormat}}<br><span class="ratio">{{age.ratio}}%</span></span>
							<span v-else>{{age.amount|numFormat}}</span>
						</td>
					</tr>
					<tr v-if="!displayList.length">
						<td colspan="16" class="text-center padding">暂无数据</td>
					</tr>
					</tbody>
				</table>
			</Cell>
			<Cell v-width="200">
				<Tree v-model="subjectId" @select="subjectSelect" :option="param" ref="subject" filterable selectOnClick multiple className="h-tree-theme-row-selected"></Tree>
			</Cell>
		</Row>
	</app-content>
</template>

<script>
	import ioMixin from '../../js/common/io-mixin';
	import manba from "manba";

	export default {
		name: "AgeAnalysis",
		mixins: [ioMixin],
		data() {
			return {
				loading: false,
				param: {
					keyName: 'id',
					parentName: 'parentId',
					titleName: 'subjectFullName',
					dataMode: 'list',
					datas: []
				},
				dataList: [],
				subjectId: [],
				params: {
					end: manba().endOf(manba.MONTH).format(),
					showRatio: true,
					hideZero: true
				}
			};
		},
		computed: {
			displayList() {
				if (!this.params.hideZero) {
					return this.dataList;
				}
				return this.dataList.filter(item => Number(item.endingBalance) !== 0);
			}
		},
		watch: {
			'params.end'() {
				this.loadList();
			}
		},
		methods: {
			loadSubject() {
				this.$api.accountbook.loadSubject({accountDate: this.params.end}).then(({data}) => {
					this.$set(this.param, "datas", data);
				});
			},
			doSearch() {
				this.loadList();
			},
			loadList() {
				this.loading = true;
				this.$api.accountbook.loadAgeAnalysis({
					end: this.params.end,
					subjectIds: this.subjectId && this.subjectId.length ? this.subjectId.join(',') : undefined
				}).then(({data}) => {
					this.dataList = data;
					this.loading = false;
				});
			},
			subjectSelect(node) {
				if (!node) {
					return;
				}
				let ids = [];
				let collect = (n) => {
					if (Array.isArray(n)) {
						n.forEach(collect);
					} else if (n && n.id) {
						ids.push(n.id);
					}
				};
				collect(this.$refs.subject.getSelected());
				this.subjectId = ids;
				this.loadList();
			},
			printPage() {
				this.doPrint({title: '账龄分析表', elId: 'ageTable', period: `截止 ${this.params.end}`});
			},
			exportExcel() {
				this.doExport({name: '账龄分析表', elId: 'ageTable', period: `截止 ${this.params.end}`});
			},
		},
		created() {
			this.loadSubject();
			this.loadList();
		}
	};
</script>

<style scoped lang="less">
	.cus-table {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #e2e2e2;
			font-size: 12px;
			height: 32px;

			&.tip {
				background-color: #FFEEEF;
			}

			.ratio {
				color: #999;
			}
		}

		tbody tr:nth-child(even) {
			background-color: #f8fbf8;
		}

		tbody tr:hover {
			background-color: #F0F6FF;
		}

		.header {
			td {
				background-color: #F5F5F5;
				text-align: center;
				font-weight: bold;
				height: 35px;
			}
		}
	}
</style>
